module.exports = __webpack_public_path__ + "img/bgimg.535161d0.png";